module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0549":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fade-enter-active[data-v-2964abc9],.fade-leave-active[data-v-2964abc9]{-webkit-transition:opacity .3s;transition:opacity .3s}.fade-enter[data-v-2964abc9],.fade-leave-to[data-v-2964abc9]{opacity:0}.velmld-overlay[data-v-2964abc9]{position:absolute;z-index:3000;margin:0;top:0;right:0;bottom:0;left:0;-webkit-transition:opacity .3s;transition:opacity .3s}.velmld-spinner[data-v-2964abc9]{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);position:absolute;text-align:center}.velmld-full-screen[data-v-2964abc9]{position:fixed}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0ef1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_index_vue_vue_type_style_index_1_id_2964abc9_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bf56");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_index_vue_vue_type_style_index_1_id_2964abc9_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_index_vue_vue_type_style_index_1_id_2964abc9_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4bad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "4d5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_index_vue_vue_type_style_index_0_id_2964abc9_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bf31");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_index_vue_vue_type_style_index_0_id_2964abc9_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_v16_dist_index_js_ref_0_1_index_vue_vue_type_style_index_0_id_2964abc9_scoped_true_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "bf31":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0549");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("53e60f72", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "bf56":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c06e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1d100946", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c06e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".velmld-parent{position:relative!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");

// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/index.vue?vue&type=template&id=2964abc9&scoped=true

const _withId = /*#__PURE__*/Object(external_commonjs_vue_commonjs2_vue_root_Vue_["withScopeId"])("data-v-2964abc9")

Object(external_commonjs_vue_commonjs2_vue_root_Vue_["pushScopeId"])("data-v-2964abc9")
const _hoisted_1 = { class: "velmld-spinner" }
Object(external_commonjs_vue_commonjs2_vue_root_Vue_["popScopeId"])()

const render = /*#__PURE__*/_withId((_ctx, _cache, $props, $setup, $data, $options) => {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])(external_commonjs_vue_commonjs2_vue_root_Vue_["Transition"], { name: "fade" }, {
    default: _withId(() => [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["withDirectives"])(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("div", {
        class: [{ 'velmld-full-screen': $props.isFullScreen }, "velmld-overlay"],
        style: { backgroundColor: $props.backgroundColor },
        ref: "velmld"
      }, [
        Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("div", _hoisted_1, [
          Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderSlot"])(_ctx.$slots, "default", {}, () => [
            (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["resolveDynamicComponent"])($props.spinner), {
              color: $props.color,
              size: `${$props.size}px`,
              duration: `${$props.duration}s`
            }, null, 8, ["color", "size", "duration"]))
          ]),
          ($props.text.length)
            ? (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("div", {
                key: 0,
                style: { color: $props.color, ...$props.textStyle }
              }, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.text), 5))
            : Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createCommentVNode"])("", true)
        ])
      ], 6), [
        [external_commonjs_vue_commonjs2_vue_root_Vue_["vShow"], $data.isActive || $data.isActiveDelay]
      ])
    ]),
    _: 3
  }))
})
// CONCATENATED MODULE: ./src/index.vue?vue&type=template&id=2964abc9&scoped=true

// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/spinner.vue?vue&type=template&id=13fb5e01


function spinnervue_type_template_id_13fb5e01_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "loader-1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 50 50",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("path", {
      fill: $props.color,
      d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "rotate",
        from: "0 25 25",
        to: "360 25 25",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/spinner.vue?vue&type=template&id=13fb5e01

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/spinner.vue?vue&type=script&lang=js

/* harmony default export */ var spinnervue_type_script_lang_js = ({
  name: 'spinner',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/spinner.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/spinner.vue



spinnervue_type_script_lang_js.render = spinnervue_type_template_id_13fb5e01_render
/* hot reload */
if (false) {}

spinnervue_type_script_lang_js.__file = "src/loaders/spinner.vue"

/* harmony default export */ var spinner = (spinnervue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/ring.vue?vue&type=template&id=22afae10


function ringvue_type_template_id_22afae10_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "loader-1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 40 40",
    "enable-background": "new 0 0 40 40",
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("path", {
      opacity: "0.2",
      fill: $props.color,
      d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
    }, null, 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("path", {
      fill: $props.color,
      d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n      C22.32,8.481,24.301,9.057,26.013,10.047z"
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "rotate",
        from: "0 20 20",
        to: "360 20 20",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/ring.vue?vue&type=template&id=22afae10

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/ring.vue?vue&type=script&lang=js

/* harmony default export */ var ringvue_type_script_lang_js = ({
  name: 'ring',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/ring.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/ring.vue



ringvue_type_script_lang_js.render = ringvue_type_template_id_22afae10_render
/* hot reload */
if (false) {}

ringvue_type_script_lang_js.__file = "src/loaders/ring.vue"

/* harmony default export */ var ring = (ringvue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/mini-spinner.vue?vue&type=template&id=65208feb


function mini_spinnervue_type_template_id_65208feb_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "loader-1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 50 50",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("path", {
      fill: $props.color,
      d: "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "rotate",
        from: "0 25 25",
        to: "360 25 25",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/mini-spinner.vue?vue&type=template&id=65208feb

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/mini-spinner.vue?vue&type=script&lang=js

/* harmony default export */ var mini_spinnervue_type_script_lang_js = ({
  name: 'mini-spinner',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/mini-spinner.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/mini-spinner.vue



mini_spinnervue_type_script_lang_js.render = mini_spinnervue_type_template_id_65208feb_render
/* hot reload */
if (false) {}

mini_spinnervue_type_script_lang_js.__file = "src/loaders/mini-spinner.vue"

/* harmony default export */ var mini_spinner = (mini_spinnervue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/line-wave.vue?vue&type=template&id=3806209a


function line_wavevue_type_template_id_3806209a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 30",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "0",
      y: "0",
      width: "4",
      height: "10",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "10",
      y: "0",
      width: "4",
      height: "10",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0.2s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "20",
      y: "0",
      width: "4",
      height: "10",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "translate",
        values: "0 0; 0 20; 0 0",
        begin: "0.4s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/line-wave.vue?vue&type=template&id=3806209a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/line-wave.vue?vue&type=script&lang=js

/* harmony default export */ var line_wavevue_type_script_lang_js = ({
  name: 'line-wave',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/line-wave.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/line-wave.vue



line_wavevue_type_script_lang_js.render = line_wavevue_type_template_id_3806209a_render
/* hot reload */
if (false) {}

line_wavevue_type_script_lang_js.__file = "src/loaders/line-wave.vue"

/* harmony default export */ var line_wave = (line_wavevue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/line-scale.vue?vue&type=template&id=01380f0e


function line_scalevue_type_template_id_01380f0e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 30",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "0",
      y: "13",
      width: "4",
      height: "5",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "5;21;5",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "13; 5; 13",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "10",
      y: "13",
      width: "4",
      height: "5",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "5;21;5",
        begin: "0.15s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "13; 5; 13",
        begin: "0.15s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "20",
      y: "13",
      width: "4",
      height: "5",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "5;21;5",
        begin: "0.3s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "13; 5; 13",
        begin: "0.3s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/line-scale.vue?vue&type=template&id=01380f0e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/line-scale.vue?vue&type=script&lang=js

/* harmony default export */ var line_scalevue_type_script_lang_js = ({
  name: 'line-scale',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/line-scale.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/line-scale.vue



line_scalevue_type_script_lang_js.render = line_scalevue_type_template_id_01380f0e_render
/* hot reload */
if (false) {}

line_scalevue_type_script_lang_js.__file = "src/loaders/line-scale.vue"

/* harmony default export */ var line_scale = (line_scalevue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/line-down.vue?vue&type=template&id=691ab5c3


function line_downvue_type_template_id_691ab5c3_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 24",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "0",
      y: "0",
      width: "4",
      height: "7",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "scale",
        values: "1,1; 1,3; 1,1",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "10",
      y: "0",
      width: "4",
      height: "7",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "scale",
        values: "1,1; 1,3; 1,1",
        begin: "0.2s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "20",
      y: "0",
      width: "4",
      height: "7",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "scale",
        values: "1,1; 1,3; 1,1",
        begin: "0.4s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/line-down.vue?vue&type=template&id=691ab5c3

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/line-down.vue?vue&type=script&lang=js

/* harmony default export */ var line_downvue_type_script_lang_js = ({
  name: 'line-down',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/line-down.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/line-down.vue



line_downvue_type_script_lang_js.render = line_downvue_type_template_id_691ab5c3_render
/* hot reload */
if (false) {}

line_downvue_type_script_lang_js.__file = "src/loaders/line-down.vue"

/* harmony default export */ var line_down = (line_downvue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/bar-fade.vue?vue&type=template&id=0e5a3884


function bar_fadevue_type_template_id_0e5a3884_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 30",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "0",
      y: "0",
      width: "4",
      height: "20",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "opacity",
        attributeType: "XML",
        values: "1; .2; 1",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "7",
      y: "0",
      width: "4",
      height: "20",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "opacity",
        attributeType: "XML",
        values: "1; .2; 1",
        begin: "0.2s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "14",
      y: "0",
      width: "4",
      height: "20",
      fill: $props.color
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "opacity",
        attributeType: "XML",
        values: "1; .2; 1",
        begin: "0.4s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/bar-fade.vue?vue&type=template&id=0e5a3884

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/bar-fade.vue?vue&type=script&lang=js

/* harmony default export */ var bar_fadevue_type_script_lang_js = ({
  name: 'bar-fade',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/bar-fade.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/bar-fade.vue



bar_fadevue_type_script_lang_js.render = bar_fadevue_type_template_id_0e5a3884_render
/* hot reload */
if (false) {}

bar_fadevue_type_script_lang_js.__file = "src/loaders/bar-fade.vue"

/* harmony default export */ var bar_fade = (bar_fadevue_type_script_lang_js);
// CONCATENATED MODULE: ./node_modules/vue-loader-v16/dist/templateLoader.js??ref--5!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/bar-fade-scale.vue?vue&type=template&id=2fadb40a


function bar_fade_scalevue_type_template_id_2fadb40a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createBlock"])("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 30",
    style: {"enable-background":"new 0 0 50 50"},
    "xml:space": "preserve"
  }, [
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "0",
      y: "10",
      width: "4",
      height: "10",
      fill: $props.color,
      opacity: "0.2"
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "opacity",
        attributeType: "XML",
        values: "0.2; 1; .2",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "10; 20; 10",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "10; 5; 10",
        begin: "0s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "8",
      y: "10",
      width: "4",
      height: "10",
      fill: $props.color,
      opacity: "0.2"
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "opacity",
        attributeType: "XML",
        values: "0.2; 1; .2",
        begin: "0.15s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "10; 20; 10",
        begin: "0.15s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "10; 5; 10",
        begin: "0.15s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"]),
    Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("rect", {
      x: "16",
      y: "10",
      width: "4",
      height: "10",
      fill: $props.color,
      opacity: "0.2"
    }, [
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "opacity",
        attributeType: "XML",
        values: "0.2; 1; .2",
        begin: "0.3s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "height",
        attributeType: "XML",
        values: "10; 20; 10",
        begin: "0.3s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"]),
      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])("animate", {
        attributeName: "y",
        attributeType: "XML",
        values: "10; 5; 10",
        begin: "0.3s",
        dur: $props.duration,
        repeatCount: "indefinite"
      }, null, 8, ["dur"])
    ], 8, ["fill"])
  ], 8, ["width", "height"]))
}
// CONCATENATED MODULE: ./src/loaders/bar-fade-scale.vue?vue&type=template&id=2fadb40a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/loaders/bar-fade-scale.vue?vue&type=script&lang=js

/* harmony default export */ var bar_fade_scalevue_type_script_lang_js = ({
  name: 'bar-fade-scale',
  props: {
    color: {
      type: String,
      default: '#CCC'
    },
    size: {
      type: String,
      default: '40px'
    },
    duration: {
      type: String,
      default: '0.6s'
    }
  }
});

// CONCATENATED MODULE: ./src/loaders/bar-fade-scale.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/loaders/bar-fade-scale.vue



bar_fade_scalevue_type_script_lang_js.render = bar_fade_scalevue_type_template_id_2fadb40a_render
/* hot reload */
if (false) {}

bar_fade_scalevue_type_script_lang_js.__file = "src/loaders/bar-fade-scale.vue"

/* harmony default export */ var bar_fade_scale = (bar_fade_scalevue_type_script_lang_js);
// CONCATENATED MODULE: ./src/loaders/index.js









/* harmony default export */ var loaders = ({
  Spinner: spinner,
  Ring: ring,
  MiniSpinner: mini_spinner,
  LineWave: line_wave,
  LineScale: line_scale,
  LineDown: line_down,
  BarFade: bar_fade,
  BarFadeScale: bar_fade_scale
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/index.vue?vue&type=script&lang=js



/* harmony default export */ var dist_ref_0_1_srcvue_type_script_lang_js = ({
  name: 'vue-element-loading',
  props: {
    active: Boolean,
    spinner: {
      type: String,
      default: 'spinner'
    },
    text: {
      type: String,
      default: ''
    },
    textStyle: {
      type: Object,
      default: function () {
        return {}
      }
    },
    color: {
      type: String,
      default: '#000'
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'rgba(255, 255, 255, .9)'
    },
    size: {
      type: String,
      default: '40'
    },
    duration: {
      type: String,
      default: '0.6'
    },
    delay: {
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      isActive: this.active || false,
      isActiveDelay: false
    }
  },
  /**
   * Append class 'velmld-parent' to parent container.
   */
  mounted () {
    this.$refs.velmld.parentNode.classList.add('velmld-parent')

    if (this.delay) {
      const delayMs = (+this.delay) * 1000
      this.delayActive(delayMs)
    }
  },
  methods: {
    delayActive (ms) {
      this.isActiveDelay = true

      setTimeout(() => {
        this.isActiveDelay = false  
      }, ms)
    }
  },
  watch: {
    /**
     * Binding outside component value and inside component value.
     * Append class 'velmld-parent' to parent container.
     */
    active (value) {
      this.isActive = value
      if (value) {
        this.$refs.velmld.parentNode.classList.add('velmld-parent')
      }
    }
  },
  components: loaders
});

// CONCATENATED MODULE: ./src/index.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/index.vue?vue&type=style&index=0&id=2964abc9&scoped=true&lang=css
var srcvue_type_style_index_0_id_2964abc9_scoped_true_lang_css = __webpack_require__("4d5e");

// EXTERNAL MODULE: ./src/index.vue?vue&type=style&index=1&id=2964abc9&lang=css
var srcvue_type_style_index_1_id_2964abc9_lang_css = __webpack_require__("0ef1");

// CONCATENATED MODULE: ./src/index.vue






dist_ref_0_1_srcvue_type_script_lang_js.render = render
dist_ref_0_1_srcvue_type_script_lang_js.__scopeId = "data-v-2964abc9"
/* hot reload */
if (false) {}

dist_ref_0_1_srcvue_type_script_lang_js.__file = "src/index.vue"

/* harmony default export */ var src_0 = (dist_ref_0_1_srcvue_type_script_lang_js);
// CONCATENATED MODULE: ./src/index.js


/* harmony default export */ var src_1 = (src_0);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_1);



/***/ })

/******/ });
//# sourceMappingURL=VueElementLoading.common.js.map